import React from "react";

const Steps = ({ marker, title, currentStep, step, waiver, hidden }) => {
  let stepClass = "step-item";
  if (currentStep > step) {
    stepClass += " is-completed";
  } else if (currentStep === step) {
    stepClass += " is-active";
  }

  return (
    <div key={step} waiver={waiver} className={stepClass} hidden={hidden}>
      <div className="step-marker">{marker}</div>
      <div className="step-details">
        <p>{title}</p>
      </div>
    </div>
  );
};

export default Steps;
